import React from "react";
import { Link } from "react-router-dom";

const HoverTiltComponent = (props) => {
  return <TiltCard {...props} />;
};

const TiltCard = ({
  name,
  count,
  Icon,
  href,
  iconClass,
  iconBgClass,
  state,
}) => {
  return (
    <div className="relative h-24 w-36 sm:h-32 sm:w-48 xl:h-40 xl:w-60 transform transition-transform hover:-translate-y-1 ">
      <Link
        to={href}
        state={state}
        className="absolute inset-0 md:inset-4 flex overflow-hidden rounded-xl bg-white no-underline text-black transition-transform transform hover:scale-[1.02]"
      >
        <div className="px-3 md:px-4 py-3 basis-24 md:basis-36 flex flex-col">
          <p className="h-[50%] text-[9px] sm:text-[10px] xl:text-[16px] font-medium">
            {name}
          </p>
          <span className="flex justify-start sm:text-xl xl:text-2xl font-bold">
            {count}
          </span>
        </div>

        <div className="grow flex items-center justify-center">
          <div
            className={`aspect-square h-14 xl:h-20 me-2 rounded-full flex items-center justify-center ${iconBgClass}`}
          >
            <Icon additionalClasses={`${iconClass}`} />
          </div>
        </div>

        <div className="h-10 w-20 bg-primaryColor rotate-[120deg] hidden group-hover:block z-10 absolute bottom-0 -right-12 transition-all border" />
      </Link>
    </div>
  );
};

export default HoverTiltComponent;
